<template>
  <section class="container-image" :style="styles">
    <span>{{ letters }}</span>
  </section>
</template>

<script>

export default {
	props: {
		data: {
			type: String,
			default: 'DPC',
		},
		width: {
			type: String,
			default: '50px'
		},
		fontWeight: {
			type: String,
			default: '12px'
		},
		fontSize: {
			type: String,
			default: '12px'
		},
		height: {
			type: String,
			default: '50px'
		},
		backgroundColor: {
			type: String,
			default: '50px'
		},
		alignItems: {
			type: String,
			default: 'center'
		},
		justifyContent: {
			type: String,
			default: 'center'
		},
		borderRadius: {
			type: String,
			default: 'center'
		},
		display: {
			type: String,
			default: 'flex'
		},
		color: {
			type: String,
			default: '#FFF'
		}
	},
	computed: {
		styles() {
			return {
				width: this.width,
				height: this.height,
				backgroundColor: this.backgroundColor,
				justifyContent: this.justifyContent,
				alignItems: this.alignItems,
				display: this.display,
				color: this.color,
				borderRadius: this.borderRadius,
				fontWeight: this.fontWeight,
				fontSize: this.fontSize,
			};
		},
		letters() {
			const array = this.data.split(' ');
			let newstr = '';
			array.forEach((element) => {
				if (newstr.length < 3) {
					newstr += element.charAt(0);
				}
			});
			return newstr;
		}
	}
};

</script>

<style>

</style>
